module.exports = __webpack_public_path__ + "static/media/bot-avatar.494223e3.webp";